export default __webpack_public_path__ + "static/media/chevrons-left-charcoal.217e2b0f.svg";